import { Flex, Text } from "@mantine/core";
import { InfoTooltip } from "../InfoTooltip";

type Props = {
  text: string;
  fz?: number;
  fw?: number;
  tooltipText: React.ReactNode;
  width?: number;
  align?: "center" | "left" | "right";
};

export const TextWithInfoTooltip = ({
  text,
  fz = 16,
  fw = 500,
  tooltipText,
  width = 300,
  align = "center",
}: Props) => {
  return (
    <Flex align={align} justify="center" gap={1}>
      {align !== "center" && <InfoTooltip tooltipText={tooltipText} width={width} />}
      <Text ta={align} fz={fz} fw={fw}>
        {text}
      </Text>
      {align === "center" && <InfoTooltip tooltipText={tooltipText} width={width} />}
    </Flex>
  );
};
